const gen = {
    _C42AE1989F20D1B6:'China Region',
    _EFECB2208C4D853E:'Non-China Region',
    _108D239E11B746E5:'Registration No.',
    _FCF219943B44B2C8:'Legal Representative',
    _B14628DB21685A53:'Registration Address',
    _D0CDC5DA95000B55:'Basic Information',
    _FF339A81358BD544:'Registration Information',
    _B0D25E6EB5FFF192:'Registered Capital',
    _5D1E56124A77D403:'Establishment Date',
    _EEB96CFF829AEFAF:'Social Credit Code',
    _7751E77D724B8E4D:'Registered Agent',
    _DAA9890CB23D1D1D:'Legal Representative',
    _22E316BFDF8585CD:'Enterprise Nature',
    _B792D74490AC5846:'Organization Code',
    _D6FBEA6F9C5256B1:'Enterprise Status',
    _2EBFE8BA794EA4C5:'Operation Period',
    _741B2155A71F27D8:'Verified Date',
    _B200C34F56DED50E:'Business Scope',
    _FCD2908E0EBED360:'Shareholders',
    _8C11957BD93982D4:'Major Personnel',
    _3501FDE979B5A4AF:'Outward Investment',
    _85F2AF69934F41B4:'Telephone',
    _908BA8F840F48F54:'Credit Report',
    _40418567ECD7328F:'Enterprise Credit Report',
    _1CCC26B9B107173B:'Basic Credit Report',
    _48ED6CBE8A4A4C1C:'Associated Credit Report',
    _798265E1F68AC490:'Annual Report',
    _362F374BF5447E1E:'Annual Report ',
    _2590799346B727D7:'Intellectual Property',
    _7912618EB31420A0:'Domain Name',
    _4E63C7F9B5510FA6:'Recruitment News',
    _37E99711B9471DE3:'News',
    _A856DAD4ED1F9BBC:'Recruitment ',
    _43335CD781012715:'Standard Credit Report (non-China)',
    _BEA758DF3F3EF819:'Professional Credit Report (non-China)',
    _AE0C9CD6D81B0191:'No target company was found? Please',
    _9345CF44233D1D3B:'Click to place an order',
    _DF676765DD3367F8:'Search',
    _BDF821D707987BE9:'No target company was found? Please select a report type and fill the application ',
    _75C45327C151371E:'Chinese Enterprise Credit Report',
    _3F2D621AFF46EB3F:'Non-Chinese  Enterprise Credit Report',
    _33F41449AA6266D5:'Credit Report Equity',
    _611362D01873C131:'Standard Credit Report Order',
    _0A9E181A82EAD7BA:'Order Basic Information',
    _F0E78FFAFDFD8815:'Company Registration No.',
    _9F3DD30CC52BFFF9:'Please Enter Target Company Name',
    _6F31B3C0CE375313:'Please Enter Target Company Address',
    _9D7D4D50ED3AEF9D:'Please Enter Target Company Telephone',
    _2F4EBF6C63C73EDA:'Please Enter Target Company Registration No.',
    _3823AFE6403FC52B:'Please Enter More Information',
    _342C5EBE3EA8531E:'Help us to find target company faster and also shorten your time for report ',
    _9881FBECD092E3A6:'Your Contact Information',
    _11AA089BD25E9FE0:'Your Company Name',
    _7F8AA50A26BDCA29:'Your Mobile Phone',
    _A7C8E306F81B1DA3:'Your Name',
    _1B52C69565300E99:'Your E-mail',
    _C62E597AAA58EA95:'Order Rate',
    _41171C31C94496A9:'Ordinary Order (15 Working Days)',
    _AC8219498AC131C4:'Report Content',
    _60ED4E39C0687805:'Report Language',
    _179B773879843F93:'The default language of the report is Chinese. For translation into English plus ￥300 per copy, and the order will be extended by one day',
    _886C688D040C28D8:'Order Price',
    _B78BE2B0D8E3F85F:'Your report will be received within <span>{count}  working days</span>, we will contact you as soon as your order is submitted',
    _6FF2FA33E7659D42:'Submit',
    _4F11D6331102CAB1:'Customer Reference No.',
    _F4E738C3F084D9C1:'Company Postcode',
    _84087137CDF5555B:'Company Fax',
    _583291904B67C121:'Company Website',
    _607D5E31D0F47A4E:'Company Contact',
    _6D2E7041A0B79EC9:'Company Contact E-mail',
    _2F8A5EDAF14BF8CF:'Company Contact Phone Number',
    _7B5149FF3D52E9DF:'Remarks',
    _368CFF5677AB20D3:'Credit Decision Report Order',
    _8C3F5A910ABB9F01:'Financial Credit Report Order',
    _B708B6A67C43EBD6:'Target Company Name',
    _E933500BC49C8B73:'Target Executive Information',
    _EE56AF8A953765E2:'Only provide import & export record reports for enterprises with import and export rights',
    _581E80E9A2A0ECF2:'The enterprise has no right to import and export, so no import & export record report is provided',
    _6ECFB04AE63B8E3B:'Remark: We will contact you within 3 days to confirm whether the target company credit  report exists. If the target company does not have corresponding credit report,we wil refund full amount  to you',
    _3AF0EEF0DAEC93D3:'The country you select does not have online report, please fill in order information',
    _F967257B46C4AC73:'My Order',
    _89B1E4B4FB72ACA6:'Order Type',
    _CD83FB1C23735AD1:'Order Status',
    _94DDC31D298FFC74:'Processing',
    _CBB75DCC686EE28D:'Finished',
    _251D996A25A9081F:'Order Refund',
    _FC9F647682076BE0:'Please Enter Keywords to Search Order',
    _50DF0F91DF131217:'Order No.',
    _653AE552ABA7120D:'Order Date',
    _EA2889BD27DA7CB6:'Download',
    _E42E5460A7D47BEB:'Order Details',
    _7F8D31C3CDA7B138:'Order Information',
    _7E512B8D9A1F513C:'Company Name',
    _373E8BE0D8840779:'Order No.',
    _E9002C8639427942:'Order Description',
    _572A34C6E9833BEF:'Payment Information',
    _ADE6B6515A35C159:'Order Amount',
    _CC892FA32E24130A:'Actual Payment',
    _9C3B1232D4BA4345:'Download Report',
    _65AAA6747A234191:'Confirm Order Information',
    _BD93ABEDF335ED06:'Payment method',
    _95700296D892965F:'Balance Payment',
    _F559F0101FFDE80F:'Third-party Payment',
    _1F707A28B289C123:'Report Summary',
    _A2B00C4D37EF8D04:'Enterprise Registration Information',
    _FFBDCA0962ACAD73:'Major Management  Personnel',
    _C4BE6E342A218A30:'Basic Information',
    _6430C03219E3C6E7:'Registration Information',
    _E9AB8E397E1D84A9:'Shareholder Equity',
    _11E7DCD211E03CBC:'Management  Personnel',
    _AAD3749ED7E7DFDE:'Financial Information and Analysis',
    _C5834EDFBB8F6919:'Operation Information',
    _366276B8A6FCBE18:'Credit Record',
    _4A344D7ABA8A3D16:'Judicial Information',
    _3AEAD3BFFB49261E:'Copyright',
    _E9FEEF93066D0DB7:'Public Information',
    _D5A38510029D8D64:'Administrative Rewards and Punishment',
    _E50796EBE5627917:'Enterprise Qualification',
    _2BD708AE5C2B8658:'Bankers',
    _439CEA406369A296:'Industry Background and Indicators',
    _B452DF6AE09ACE90:'Comprehensive Analysis',
    _AB288C74A8147006:'Credit Rating/Credit Limit (The content of the report may vary depending on the type and size of the enterprise)',
    _E8B1494F45E1823A:'Credit Rating',
    _0DBA5B3705AB3F8A:'Credit Limit and Credit Term',
    _5E8A621D18ADF05F:'Enterprise Operations',
    _FCC20298D733713C:'Enterprise Financial Information',
    _0E2756CB27889D56:'Industry Background and Industry Indicators',
    _43659561B66B5B6D:'Enterprise Risk Evaluation (The content of the report may vary depending on the type and size of the enterprise)',
    _2E5D5454255E0145:'Enterprise Basic Information',
    _815FDFC4DABE3A9A:'Latest Financial Status',
    _3B6F1B2BD90B8ABA:'Industry Information',
    _7F5A6399D7FA9FCB:'Credit Rating/Credit Limit',
    _5DB2703036C56C4F:'Operating Activities',
    _C7AA1D06BC8BF617:'Used Name',
    _B341130A9B3B4B97:'Old Enterprise Type',
    _F4BD0286B0EF1508:'Contact Information',
    _D04F400509633786:'Negative Information',
    _428E6CAF92CBE5AB:'Payment Information',
    _0937F10C95DB9D12:'Management Board',
    _63DC1BA360A621DF:'Ownership Structure',
    _328B7C087FF9FA8B:'Group Structure',
    _747C1A49D39FCC0E:'Related Companies',
    _7B62F7121421F76C:'Other Informaion',
    _5A6C768555DF305B:'Financial Information',
    _C062FC6D69CB9AEA:'Income Statement',
    _071226E07B78C0FE:'Balance Sheet',
    _A477D0C7222AB97D:'Other Financial Informaion',
    _C1DF8F5B9B639ED2:'Ratio (The content of the report may vary depending on the type and size of the enterprise)',
    _32AE7480C5748DAD:'Customs Rating',
    _AAD1C9F25083F758:'Import and Export Record',
    _55D2D24204BBFF00:'Enterprise Associated  Information',
    _69CB8C47FBD7DCA5:'Latest Financial Status ( Individual Company)',
    _D214842FE9E291E6:'Public Record',
    _47E2037B97106B23:'Judicial Record',
    _0BDCE3AD4A5082D7:'Executives as Legal Representatives',
    _9164CB12CEE9D3F9:'Executives Outward Investment',
    _D5F34645689F3E74:'Executives Outward Position',
    _CE4E5DE783CE2519:'Enterprise Outward Investment',
    _25F59D0E09AEC79A:'Standard Credit Report',
    _C8ACB3D947BFF58E:'Credit Decision Report',
    _14F9CFD423C00C71:'Financial Credit Report',
    _E0D04F8141FCD790:'Overseas Online Report',
    _AA4FF4F728D36439:'Overseas Offline Report',
    _322755C8195C2DA8:'Import and Export Record Report',
    _66FB6CC362C1E7A2:'Executive Associated Report',
    _FA3A12C41D899454:'Enterprise Associated Report',
    _C79AA2E1C4BFF94F:'Comprehensive Insight into Enterprise Status',
    _55E93A69117E2919:'Forecast Transaction Risk',
    _FC8A68E01DA266E9:'Make Advantageous Decisions',
    _21D7E5D8A30B9664:'Quick Insight into Customer Strength',
    _C320D07D47B1C9EF:'Identify Cooperation Risk',
    _CDB87173DEEC9B25:'Quick Decision',
    _9EFC529DD6887260:'Comprehensive Analysis of Enterprise Financial Status',
    _C3C0D3201C9D1439:'Assess Solvency Effectively',
    _146AC35CFC9D559C:'Profitability',
    _6ADD89C4F2264B14:'Compile Import and Export Data & Customs Rating',
    _C2C6FC45A4E98EED:'Investigate Transaction Risk',
    _FE3BD659D5972D70:'Seize the Market Opportunities',
    _28609E4A29B0DC12:'Compile Import and Export Data ',
    _152DF7A9DB7AE748:'Obtain Enterprise Basic Credit Information Easily',
    _8F5B2157C3CEF520:'Multiple Dimension',
    _190CFF21109184E5:'Cost Effective',
    _A9684446D236BF4C:'Effective Support for Quick Decision',
    _29F045EC85979AB0:'Display Executive Background',
    _9096AD42BCA1E24C:'Understand Associated Enterprise',
    _71F34DBCC1460A2D:'Forecast Transaction Risk',
    _6A5863FAE0C52811:'Dig Associated Enterprise',
    _24560E03362D23EC:'Prevent Risk',
    _A3A129DBA93AD960:'Urgent',
    _41FDBAC1A7663940:'Extra Urgent',
    _1B3E8112733CB50A:'Ordinary',
    _09D790D62F41A724:'Ordinary Order',
    _F01431F8B926B2A8:'Urgent Order',
    _49F2520F7BE2170B:'Extra Urgent Order',
    _198EA993107833CD:'The company verification you submitted is under review',
    _C475667934952A08:'The company you submitted has been verified successfully',
    _F1A99ABAA3A70857:'The verification of company you submitted failed, please update and submit again',
    _390F6F28C9DEE4D0:'The upstream and downstream companies you submitted are under review',
    _54F94A48F24A92CC:'The upstream and downstream companies you submitted have been verified successfully',
    _5276FF277F161100:'The verification of upstream and downstream companies you submitted failed, please update and submit again',
    _0AA51AA60F02B5AD:'The feedback you submitted is under review',
    _CF94FD9A6CCB1145:'The feedback you submitted has been verified successfully',
    _4C737C69864AC79F:'The verification of feedback you submitted failed, please update and submit again',
    _B5B792F350314A12:'Credit report has been completed',
    _3A2A96BF6BDDC66B:'Your credit report has been completed, please download your report from "My Order Center"',
    _9259342BD395862F:'Order Notification',
    _35877B9B563CDA0D:'Failed to complete credit report',
    _3B9F2A5887298749:'Sorry, the target company you entered has no corresponding credit report, we wil refund full amount  to you',
    _F3D4EDFDA3D730F7:'Your credit report has been refunded successfully',
    _A362918B62A3B3CE:'Your Contact Number',
    _4C1D13253B871BF8:'Your E-mail',
    _D5F2C854A21A8F9D:'Report Type',
    _DCA0137D882B1569:'Account Balance',
    _576E21636CA8050B:'Refresh',
    _6608E89B5B203542:'Recharge',
    _488E2DF9525EB78F:'Submit Order',
    _E41D73EF52565FB3:'Please Enter Content',
    _7F5A154D10F8E4CC:'Please Select',
    _A78B0C0E20923692:'Search',
    _CD9A7C4D08858782:'Registration No.',
    _6799AB98CFC957C3:'Company Contact Number',
    _C22A3DCE17C95815:'Postcode',
    _85F2A0D2D7E5A9ED:'Company Contact Address',
    _8DCDB6B183A21704:'E-mail',
    _44A3F2F4EAB7387D:'LLC Whether shareholder (sponsor) equity transfer occurs this year',
    _FDE22E8368908B49:'Operation Status',
    _6DAFDE31DD57E67D:'Website or Online Store',
    _D57B50DCF68E167A:'Outward Investment Enterprise Information',
    _EBF0BD3AD98D7DB8:'Employees',
    _6FA6268A4CC79C01:'Website or Online Store Information',
    _D01612AF6B1EE85D:'Type',
    _C34ACDA7DACF54CB:'Name',
    _AED1D9AB6EDA12BE:'Website',
    _861F52A72076998E:'Shareholders and Investment Information',
    _B55ED213072D695D:'Shareholder (Sponsor)',
    _9CB7B0B894740EE6:'Amount of Subscribed Capital',
    _E1037F1840E1F5B8:'Date of Capital Subscribed',
    _108FA0EFED779A9D:'Amount of Paid-in Capital',
    _F4B40814C3D408EC:'Date of Contribution',
    _B5098F7CA2BD9B48:'Form of Contribution',
    _D32A490F379A4EC5:'Outward Investment Information',
    _32C2EB8EB4414C29:'Name of Investment Company or Company with Share Options',
    _465DB114FC46C912:'Enterprise Asset Status',
    _0C760C33A211D35D:'Total Assets',
    _D35A810CD44AC3A8:'Total Liabilities',
    _816FD35C491B13B5:'Total Sales',
    _7DA6D4EF658AF2D7:'Total Profit',
    _D4947A4AC51F33F1:'Main Business Income in Total Sales',
    _D42F540C485908EB:'Net Profit',
    _BB01EFCD8AC76E6A:'Total Tax',
    _9CAD59049F980014:'Total Owners\' Equity',
    _E45D70066D89CD70:'Guarantee Information',
    _D3E31318F5E4FC01:'Creditors',
    _C3BA6907DD11BA3A:'Debtors',
    _AE9C87B493BB8A36:'Types of Principal Claims',
    _C6A2117FAAD47AB6:'Amount of Principal Claims',
    _1EAA62161687D054:'Period of Debt Performance',
    _4083F22199C8E38E:'Guaranteed Period',
    _80A9871A093ED452:'Ways of Guarantee',
    _F23B0F32AEC3C1EA:'Scope of Guarantee',
    _97ED12A072E32C7A:'Equity Change Information',
    _80D655B93E2CD5EE:'Shareholders',
    _2E7C2688E1AE17E4:'Equity Ratio Before Change',
    _C380CB21FEC46617:'Equity Ratio After Change',
    _F497FFC1F82B7A81:'Change Date',
    _7A6DAF301BF39469:'Modification History',
    _9054E8102BE31F07:'Particulars of Modification',
    _B980437348C6CC3C:'Before Modification',
    _CD9504E5343FAD7D:'After Modification',
    _5288D6774D159320:'Modification Date',
    _4BC5C9AE9D8F6EDD:'Company Name',
    _767DDCA435EF5A0D:'Fill the following optional fields to help us find the target company faster and also shorten your time for report ',
    _B1012AA778374C49:'Please Enter Customer Reference No.',
    _4D85895D28F46A6B:'Please Enter  Postcode of  Target Company',
    _BBA120022832DD52:'Please Enter Fax of Target Company',
    _4D1E820F87E538CC:'Please Enter Website of Target Company',
    _143AEA38D02DBA93:'Please Enter Contact of Target Company',
    _3998ACF8871BD025:'Please Enter Contact E-mail of Target Company',
    _9C1ED421D685C715:'Please Enter Mobile Number of Target Company',
    _3B86B63CA0BB4EAB:'Please Enter Your Other Requirements',
    _E18DB53BB2AFDFE5:'Please Enter Your Company Name',
    _211E217275F0A9BE:'Please Enter Your Name',
    _313601EBF9409213:'Please Enter Your E-mail',
    _D719DD6293A6E32B:'View Report Samples',
    _05062D64F28822F8:'Chinese',
    _0F7DB03985F4166D:'English',
    _E40D8942489AF29B:'Target Company Information',
    _B9FFAFA17F984141:'Select All',
    _4D5E53F75D3B003E:'Please Enter Executive ID No./Passport No. for More Precise Query (Optional)',
    _0F625AAA0CFC02CC:'Only VIP members can submit orders, do you want to open VIP function?',
    _1B039DBA24905254:'Open',
    _BF54E1A123011E86:'Credit is Capital',
    _9BFD30568442E843:'Obtain the global enterprise credit management service right now',
    _274D55D888C104DE:'China',
    _FE86492B8B77C0F7:'Non-China',
    _BA857CAE4E2A39EE:'Meet All Credit Survey Needs',
    _AD5C2CF813168405:'My Report',
    _BB9B2CCD4323ECB2:'Confirm',
    _15D206D3771D2BCA:'Report Details',
    _558CE585DF178AE3:'Yuan',
    _FDD8ADDF0E19DE64:'Chinese Company List',
    _30C6AD872C5D9F00:'About {count} related companies are found，top {front} companies are displayed',
    _DC806EEC155CA5F0:'Company Details',
    _5E5E9CD11863C989:'Contact Number',
    _C94FF80392CDF3E2:'Introduction',
    _D13AD477DC9D355E:'No company profile',
    _AA631B2DD2583BE7:'RMB',
    _8C4FFBA1D09C3D42:'Special Credit Report',
    _BE80CBE68207893F:'Registration Date',
    _54D23372288B4696:'Source',
    _8B012D89E90E462B:'Working Place',
    _8D7C22F51289659F:'Reward',
    _433EE42D472D7CE5:'Your order has been placed successfully',
    _A8B3CDCE6ECDFCB3:'Your order has been paid successfully, we will contact you as soon as possible. If the target company does not have corresponding credit report,we wil refund full amount to you',
    _7BF32D32BBDBDBFA:'No enterprise annual report information',
    _86EBA604673A6287:'No intellectual property information',
    _DAD78F91C6F5D37F:'No recruitment news information',
    _4F419DF0ADA8B931:'Chinese Standard Credit Report',
    _B6CE57F276ADA567:'Chinese Credit Decision Report',
    _A2027BB46444D4FB:'Chinese Financial Credit Report',
    _30D93B194C1C942B:'Overseas Standard Credit Report',
    _13E304066C672EE1:'Overseas Online Professional Credit Report',
    _2DC686625DC2DD54:'Overseas Offline Professional Credit Report',
    _7E05356CC20AF027:'Chinese Import and Export Record Report',
    _395BDA3B625561C7:'Chinese Basic Credit Report',
    _B5CDF55A48182B7A:'Chinese Executive Associated Report',
    _D6EACED55DD87490:'Chinese Enterprise Associated Report',
    _CC869AC1A9FC3AA9:'Get extra 10 times for contacts views by E-mail invitation',
    _2BB6686E5F5D2506:'Get extra quota by E-mail sharing',
    _054789FE3D92F8EE:'Get extra quota by company certification',
    _200C3AB2843FC88D:'Refund successfully',
    _BE32F3ED4DA26C91:'System Notification',
    _EC8DEBEDCBF8A9AC:'Your money has been returned successfully to your balance',
    _184D2790C3FBE043:'Your order has been placed successfully, we will contact you as soon as possible',
    _A57473800DE3F3BB:'Company certification',
    _D483F385C3B31538:'Feedback',
    _6CDBFB91A5DD8CD5:'Upstream and Downstream Companies',
    _6CE10C1138854A48:'Or you can copy and forward the following link',
    _A27C3E84F6D407C3:'Order payment failed',
    _AB85B18BA5D629F0:'Please Enter the Country of Target Company',
    _55263C127A677B9F:'Company Address in English',
    _F5C2331CCA57E116:'Please Enter the English Address of Target Company',
    _37B2ED9C5348B0BF:'Company Name in English',
    _D8C020F68EFA4B27:'Please Enter the English Name of Target Company',
    _07EEA32FB91CE9E8:'Company Contact Number',
    _8915CBC3ED44EF0D:'Please Enter the Contact Number of Target Company',
    _B1387BFBBE467173:'Company Name ( in Local Language)',
    _8A893879F133DAC3:'Please Enter Your Mobile Number',
    _7DF8F3E33E06678D:'Please Select Order Type',
    _FF1BAFDE4717EA6A:'Order Category',
    _5646913679F809AF:'Your report will be received within <span>{count}</span> working days, we will contact you as soon as your order is submitted ',
    _571028FC767E8570:'No target company was found? ',
    _E86BB502001F5715:'Please select a report type and fill the application ',
    _A2045ABA52829947:'Professional Analysts Help You to Avoid Risk Effectively',
    _FA5B35DA3E0ECE76:'Seize Business Opportunities and Make Decisions Quickly',
    _D5086778379D1070:'High Cost Effective',
    _A5D97E7993456ADE:'Chinese Credit Report',
    _3FEA1EF958F1DB10:'Comprehensive credit reports, help you analyze business strength of the target enterprise, fully understand enterprise\'s detailed background、credit record、latest operations and financial information, etc.',
    _794A78F94FA88B27:'Special credit reports, focus on different fields such as finance、import and export record 、executive information, enable you to obtain enterprise specific information according to your own credit investigation needs.',
    _3449CF6B27A783E1:'Full Insight into Enterprise Status',
    _B563FFFE212529A2:'Analyze target enterprise in multiple dimensions, fully grasp enterprise\'s credit status and predict cooperation risk.',
    _96B0345149914A30:'Efficient Decision Support',
    _CFAF35D3024C113A:'Report can be completed within 3-7 working days. Authoritative analysis helps to assess target enterprise\'s actual financial situation and credit risk, provide strong data support for decision making.',
    _2F3A3A366FD8E567:'Overseas Credit Report',
    _4F4B421400C1D552:'Authoritative Information Source Channel',
    _3988D4400FD84E81:'Deep cooperation with overseas professional credit agencies, higher authority and more reliable information source.',
    _4629054970EB083C:'Accurate Survey on Global Enterprises',
    _9B6344D062544D38:'Assess target enterprise\'s credit in multi-dimensions, global enterprise and contact data to supplement the background information of the enterprises, enable you to obtain the real-time data of the target overseas enterprise.',
    _BE059F8A6DA308ED:'High Cost Effective',
    _E65E939E26214EAA:'Our reports are cheaper and also richer in dimensions, ensure you get a low price and high quality credit report.',
    _C440E38573D0145D:'Ensure Transaction Safety',
    _FE739EEF3080DD68:'Monitor credit status of target enterprise in real time, professional analysis group helps you to avoid cooperation risk and ensure your transaction safety.',
    _B10630E0D8D13FD3:'Customers Feedback',
    _43B40D3F1F22732D:'Our customers are widely dispersed in the European and American countries, with the aid of Xieco credit report, we can fully understand our overseas customers and avoid transaction risks at the beginning of cooperation.',
    _08B5BE7DD2CC7D75:'We have more than 300 suppliers all over the world. It\'s very difficult for us to investigate and inspect our suppliers. Xieco credit report can help us easily obtain our global suppliers\' operation information and provide decision support for us to select stable partners.',
    _F40FA0794B5CA32D:'Xieco credit report helps us to deep understand the financial status and payment ability of our partners before cooperation, makes us to avoid risk and have no worry about international transactions.',
    _4CD6A108A46704A8:'Please Enter Company Name in English',
    _BE8E294684E939D9:'We provide credit management services for thousands of customers to solve their credit risk problems. We have offered different solutions before transaction,during transaction and after transaction to solve billions of transaction risk issues and won praise and trust from customers.',
    _F29BF0DACABC8ED2:'Company List (China Region)',
    _2D59C19603FD5527:'Company Details (China Region)',
    _591EB3EC5759E4B0:'Company List (Non-China Region)',
    _9BB75D9C0059F25E:'Company Details (Non-China Region)',
    _FC3489F65384534A:'Status',
    _A1660A1A4BE5FFB8:'Sorry, no credit report information',
    _33BB118CC1BFF7C6:'No target company was found? Try submitting a custom form, we\'ll search manually for you.',
    _B822D59484EAEB7B:'The following 2 credit reports was found.',
    _1AFDD3DBEEBD530A:'Credit Leads to Trust',
    _8753146967499F32:'Pay credit report with balance',
    _63F4064ABFE70969:'Take credit as a principal,  help you fully understand your business partners and make quick decisions',
    _653DF5A8CAA01210:'A certain international trade company',
    _AAD9EB0E0B90CCCA:'A certain electronics manufacturer',
    _E848C54912EC40A0:'A certain stone exporter',
    _CBCEEC8F25DF0115:'Mrs Zhu',
    _E1533A568DDBA971:'Mr. Wang',
    _7DBA136D2733BCEE:'Mr. Zhang',
    _3499BA5DD7693F05:'Pay Now',
    _277941AB912CAF81:'Order paid successfully',
    _9AE17C15C2E1D2A5:'Payment failed',
    _AEC13FDCDF01EDE1:'Your balance is insufficient',
    _7427F8736073413F:'Unpaid',
    _74FB3F436F1EB255:'Chinese company data content has not been translated into English,the corresponding function will coming soon.',
    _1A0F989BBBCDCFC5:'Prevent Related Risks',
    _0CFFCCB570AC3B58:'Address',
    _C34725BB187861E4:'Ordinary Order（{count}Working Days）',
    _9A394E936AF30A86:'Urgent Order（{count}Working Days）',
    _81BE62CD6CE166D8:'Extra Urgent Order（{count}Working Days）',
    _AEA865E0CD84E93B:'Payment failed! Please try again!',
    _89A7600CA59186EE:'No URL',
    _BAD350CE30545BA7:'No regional information',
    _98F1363FFA0DEDE2:'No information',
    _FEA78BAA195C36D0:'Xieco- Global enterprises search',
    _A6DA3FF15AAAC41F:'Search companies',
    _34CA36149B6958CC:'Search contacts',
    _F68A25D0A8347803:'By Company,Product or Website',
    _A8EEDA4301C24523:'Over 60 million companies and 450 million contacts',
    _4C84BC23E0FC197B:'Create an E-business card to get precise recommendations',
    _1BA95A7C35301834:'Create business card',
    _EA18C206890A8C81:'Hot Search',
    _19538F4716FBCE73:'Login and create a business card to get more precise recommendations,  login now',
    _81DE78B8032F1A6C:'No company interested?',
    _DBD2FA5F62010533:'Add more industry and product information to help us recommend more contacts for you',
    _5B392C5B70AFDDF5:'Create a business card',
    _3A9BE28F7F4A0183:'Add product information and videos in your business card can help your customers know your business better',
    _50C38898BCB9F6AE:'Recommend for you ',
    _6B706D82DC53B940:'Not satisfied with the results?',
    _8E495D2BAC44DAD7:'Complete tags to get more precise recommendations',
    _EF21C34D37215773:'Go to Setup',
    _9438F34A0171B07B:'Setup Model',
    _0BA1FA8EDD805D16:'Country/Region',
    _05B9138394F3B4BF:'Number of Employees',
    _A8854B476402BAF7:'Annual Revenue',
    _CCD0ECFF8EA66B08:'Industry',
    _723CCE425E1DF36E:'Industry Keywords',
    _43249C38B053C526:'Product Keyword',
    _319766795B2EA0DB:'Sample Companies',
    _7AAE1129E04FDEB5:'Save',
    _5A2CB47F82C68789:'Reset',
    _77174ACF204D0C0A:'Please enter industry keywords',
    _2388069251B4E253:'Contact',
    _AD29ED014EA5BA02:'Favorite contacts',
    _67F2F1A60FA733F4:'Favorite Companies',
    _3F17028A0DB4D688:'Profile Views',
    _EE6850D8CFD141C2:'New visitors',
    _12D8E2B2C940D826:'Recommend For You',
    _D8A72A9A18DE4FAA:'You have not completed business card yet, no contact recommendation for you',
    _07FE9A67EAE94A35:'Complete business card',
    _EF26ECAFAA65F8D0:'Added to favorite contacts',
    _3953426EFEE247E2:'Edit',
    _6AEAC506A69E32BB:'Send Message',
    _3CFD87426BF1648D:'Edit group',
    _40BAB16E44819D11:'Delete contact',
    _ABD3BFEB90ABA621:'Person in touch',
    _15322670FC5C306E:'Messages',
    _135743FF6B153099:'Contact Name/Message Content',
    _C75FC661D9FECCFD:'InMail',
    _717005B0750B96AE:'Email',
    _8A540A2B7B422B04:'Business Card',
    _5F0FC134E152D4CC:'System Messages',
    _3F83850B507368F9:'**Unread',
    _A22C8DBA0BEFD699:'Send a business card to you',
    _D3056B3E9BC8E069:'Your credit report has been completed, click to view it',
    _4F315AB55395C02E:'Click to send a business card',
    _C13DF50E5D9A9B38:'Business card has not been completed',
    _8E544AE849F9B247:'Your business card information is incomplete, please finish card informatin first',
    _E1902F5A973DC466:'Cancel',
    _9732C79D274798DB:'Complete business card',
    _739C30008888F092:'Mine',
    _25CA9B62E14C3817:'Recharge',
    _CF7B6478555ED736:'Upgrade to VIP member',
    _CE529229D4E42E75:'VIP Member',
    _F810433E950D3566:'Expire Date',
    _A889E38F1DEB4CAD:'Expense Details',
    _F6124616F74790E9:'My Business Card',
    _918B6BF4D1F9B0D5:'Complete to get more precise recommendations',
    _1DA27B31FB6FB7C4:'My Model',
    _793AC7049D8DAD9D:'About Xieco',
    _AA8AEC1653BB702A:'Log Out',
    _F260F67BB46A09FC:'Personal information',
    _5BA120792C93CC75:'Name',
    _C1C06DEDB67E0394:'Phone number',
    _9FB1511F382D772D:'Email',
    _5B04EFE72FA80E4F:'Post',
    _CAB254FF0D8CE210:'Edit personal information',
    _B710FDBE9A2B10D1:'Basic Information',
    _7F6279B6099B52C2:'Company',
    _FD4CA0D4DDBA5BEA:'Website',
    _1A03065EFE5A6926:'Profile',
    _A3AAC2A75B7C1FA9:'Company Tags',
    _275CC5A9280A5A1C:'Edit Company Informations',
    _38DB07404F1DF098:'Company Products',
    _357D8ACDBB351CD5:'No product added',
    _EDF0091560C61D79:'Edit company product information',
    _43574CF7DA001080:'Videos',
    _091359354AC11B13:'No video added',
    _CC5837568DEC5C96:'Edit product video information',
    _57BB22A10B008686:'Add ',
    _B3382463A7AA33FB:'Add product photos',
    _7D485EDCDA2AAEC4:'Product name',
    _2A8F9B236FD83253:'Product link',
    _57653428E14F7782:'Product description',
    _DA93D395C597AED9:'Add ',
    _A86253C9AD264BB0:'Add video cover',
    _7F2AEE58090222DD:'Video link',
    _D0A1658F85795188:'you can upload video to video websites like Youku (YouTube) and then copy the link',
    _B7B0000677FD9B91:'Video title',
    _4D4DBE29D29D2128:'Please enter',
    _23FE82ADBBDB53E9:'Business card view record',
    _59F4B0CD43E5ED83:'You don\'t have any business card view yet',
    _942AC6ABE5549AF3:'Two steps to expand more contacts',
    _9B50D5F98086DB11:'Complete card information',
    _BE45D0199CAB4A95:'Send a business card',
    _3001A883DD2E74CF:'Strange visitors',
    _537549EA6D49FC0B:' Visit record',
    _FDF1EF9B8C8C8E9E:'Visit time',
    _BA9DD426B20A0DB0:'Wechat ',
    _89C85EF2AC06B18E:'Alipay',
    _DA45B7D8378BD4E4:'Confirm Payment',
    _CFB15065868CB5D7:'Upgrade to VIP menbership to unlock more functions',
    _1EF1936B851136A7:'Standard',
    _C0D91E4F1F776D1B:'VIP',
    _597464741724C2AD:'Display number of query result',
    _72DC2E074553CD2F:'Export data',
    _9BA58BB7F51B4CA9:'Company basic information: address、telephone、business scope、website,etc.',
    _9120200E6800DECA:'Advanced screening function',
    _B65E5F6CD2571DDF:'Country、scale、turnover、industry,etc.',
    _C7286B64327DEBBB:'Guangdong ICP Record No.18069201-1',
    _0D62E92D0BD3A446:'No result was found，try another search term?',
    _1CB107827EE006CE:'Fill in target company information',
    _0F006942431FDBEC:'Fill in target company information and your contact',
    _A1624725A9FD0F0C:'Report Advance Payment',
    _3714801E3889185F:'Waiting report completion',
    _78097239AD02A903:'How to get credit report of the target company?',
    _9CF23A3BC6F6ECEF:'Immediate report of 11 countries: Britain, France, Germany, Italy, Ireland, Netherlands, Belgium, Luxembourg, Norway, Sweden',
    _AE275BC6C2D12362:'Sorry, you\'ve run out of visitor quota, please login',
    _12F1CBE93D6BEF0A:'Global Enterprise Due Diligence',
    _65343CB79BC5A3DD:'Help you quickly investigate enterprise credit, analyze competitors, recommend partners, and achieve efficient and safe transactions',
    _5F3C67AF1D997218:'Global Enterprise Contacts  Recommendation',
    _596B3FE0D4FD3C03:'Help you quickly find enterprise contacts, recommend cooperative contacts, and achieve fast and safe transactions',
    _54D1A8EA08E80735:'Sorry,failed to get token.',
    _AF6DC5BCA6B96CAB:'Registration verification code',
    _49B1C04E04567211:'Verification code for email connection',
    _E2DDA9D62F258EED:'The keyword cannot be empty',
    _1A3126B313DC9692:'Ordinary members can only view the first ten pages',
    _CFA7C6E4FB09D9F2:'Sorry, you\'ve run out of quota',
    _DEEC0FAABA4C33A0:'Acquire contact failed',
    _A43B950B31ED3CF1:'Acquire company failed',
    _C1010E70CC0EA895:'Parameter error',
    _B2ED798DE5151645:'Operation failed',
    _D1CAE6C1D71C76BE:'Sorry, you cannot have conversation with yourself',
    _53987E59B7E0A849:'Incorrect link format',
    _A0B1983ED3F622A9:'Nickname cannot exceed 50 characters',
    _B8B41ABE269C9E75:'Name cannot exceed 50 characters',
    _6EE6826FD0533EEE:'Company cannot exceed 200 characters',
    _C81ADC5C2D9C0BB4:'Position cannot exceed 50 characters',
    _1D8CE6C009EB18B6:'Address cannot exceed 200 characters',
    _2F620189723F1534:'View All',
    _50CE5624B31AFDE2:'No data available for this section',
    _88EB55B8475184EC:'No data available for this section',
    _3CB86ACDFACDC2E9:'No data available for this section',
    _E17C5ECB110E0FE4:'No data available for this section',
    _28B54BEA107EBB8B:'No data available for this section',
    _8D69591B29180004:'Buy Report',
    _B20E22C52E12B1AA:'View all domain names',
    _559276D58F3A9973:'To',
    _59BA909400B60C9E:'Business Registration No.',
    _D45C5F9EC04ABB48:'No annual report for the company yet',
    _9829CA6937637ABE:'Are you sure to delete this company?',
    _1B2B292E4E793C9C:'Are you sure to delete this contact?',
    _D2E47AE7C6D4E04D:'Search Company Now',
    _9D904A4A90D6BEB0:'Search Contact Now',
    _C2584632CFC3510B:'Add to favorites to develop business',
    _1E5E80544E3B88D7:'Add to favorites to develop business',
    _4D02C4BDA664C102:'The keyword has already existed',
    _7AD2BC5A881630B8:'Please enter sample company',
    _97811B1C0A748E7B:'Please enter industry keywords',
    _EB6249E409300659:'Please enter product keywords',
    _38F80563867C1563:'No Limit',
    _38AFB5DF36907ADD:'Clear history',
    _79BE6EDA26BF8D6D:'Clear search history completed',
    _6D6633ACA71AFB07:'Share To',
    _C4163A3C500B2F37:'Please use the browser\'s',
    _E17E20A3F83F4737:'share function to share to Wechat',
    _6C087EC792D87414:'I understand',
    _9D4C8A1B173382AA:'Add Now',
    _93BB8530DA5A9C75:'Enter your company for a more accurate match',
    _9B3A9AD93CFB6409:'Nothing is found, please change a search term',
    _E3D99ADB6C72379A:'No data to filter ',
    _61271625D42B0EA2:'The product keywords are required, please do not delete all',
    _BFC83DB6CC145967:'By Company Name in Chinese',
    _16CC3AC457CCE4AC:'View Email',
    _2E761A17033BEF70:'Please select the company to view',
    _9D9D62A53D9C5CC4:'Company Tags',
    _1412A718B3127FF6:'Affiliated Companies',
    _703FF40A143C4F8B:'Add ',
    _3F0ACACE701EB05A:'Major Contacts',
    _C6B4B818DF375C38:'No data available for this section',
    _1F6993CAD3B3306D:'No data available for this section',
    _6454BBE8C42A58C6:'No data available for this section',
    _23732EEA1F108F83:'No data available for this section',
    _FF4A16D3A35A2FD6:'No data available for this section',
    _4E55E107121DDE2B:'No data available for this section',
    _524A5F08E086A2C6:'No data available for this section',
    _40995FCA6E433A67:'No data available for this section',
    _C72F446DDC5B39A4:'No data available for this section',
    _0F65F29A1B393020:'No data available for this section',
    _B6F90EA7B4179959:'Professional Credit Report',
    _92A07363E0D9CD5B:'Standard Credit Report',
    _35F89CCD40862F62:'The contacts in this group will move to the default group after deletion',
    _66399285087F7F49:'Modify successfully',
    _6A130A192F26B4DB:'5 times/month',
    _2466F37F275D60D2:'The data covers 218 countries and regions around the world',
    _D77FB1C0C64A81C3:'Multiple Choices',
    _6CCBBB51F80666CF:'Social account',
    _71ABF8439D561DF2:'Not exclude',
    _BD1B321EF1897552:'Non-Chinese Companies',
    _21535E03C95160AD:'Searching related customers according to your criteria',
    _AF6134C248F67FAB:'Please select country/region',
    _650C09FEB763D570:'Please select industry',
    _FCE84B705C7FA099:'Please add product keywords in English',
    _38787358E95233BF:'Recommend for you',
    _5F6B537122D4444E:'Please provide the following information, we will recommend potential business opportunities for you',
    _0B13C130A6E126D1:'The product keywords are required, please edit again!',
    _985C17DDE0E4E37F:'This process may last for one minute, please wait patiently',
    _25855C63A4784ABA:'Chinese Companies',
    _3779A04EC830D6AB:'Non-Chinese Companies',
    _EDAC839AA3DD6515:'Recommendations match your criteria',
    _FD74E6FFE4DC8697:'Job Function',
    _8EECDE592A70EC2E:'Level',
    _6A5CF4BE7CB326F5:'You have to log in first to use the filtering function. Go to the login page now?',
    _EE05CBB70DE153A4:'filter',
    _A0958567B3A0CCA2:'Get more precise result?',
    _AB1EEE5BF6C5A91F:'{count} results are found',
    _C4F4084C31F54F02:'Intelligent sorting',
    _917ABA70742BA520:'View Report',
    _9252D22E454D8782:'Home',
    _23C8B7E8887D8C72:'Exclusive customer service',
    _9C2B2D7A43D0A072:'Reset Password',
    _CF8D2623F2556134:'Please enter the correct email address',
    _0582F9C340B60DE8:'Please enter the correct phone number',
    _9B031F04C4279884:'Send Code',
    _A3E23EA97F8EEBC5:'Delivered',
    _95B1BD0E489AD4D8:'Verification Code',
    _FA2FF9E7AB2D8FB6:'Password',
    _FB7124170D9D8469:'Phone Number',
    _478D82D23C19B667:'Email',
    _B801B649A6E6CCBC:'Facebook Sign In',
    _F01C21183D04FB87:'Linkedin Sign In',
    _38329EDBC3E9E899:'Twitter Sign In',
    _E272C9F65D24A6A4:'Wechat Sign In',
    _5726B3CE743958AE:'Verification Code Sign In',
    _DAAA7C74116084DD:'Get Code',
    _CE5B5F49C2B88103:'Release to load...',
    _1CD3AA2CD48F6A49:'Fill in the content you want to send',
    _81F797A1DDFF5EDD:'Pull down to load more…',
    _664C820267A734D6:'Order Messages',
    _E82B1822DF79A07C:'No message meets the criteria',
    _11D7417368BA147F:'Social Authentication',
    _2C23A15ADA54F02E:'Contact Us',
    _D2F62B201C5B9A7A:'Global Company and Contact Search Platform',
    _22479F2FEAC8E7E0:'Please enter company tags',
    _B5291DD2F01BC65F:'Add Company Tags',
    _09873FBAD0B9F686:'The content will display after approved by admin',
    _6259F53E4B5CFEC7:'Save successfully',
    _AE3E59176C3B1389:'Expense beyond member quota',
    _ABBA1189C59FD5BF:'Total',
    _1371EE4BA960DF94:'Usage Count',
    _9D826D9CFF36AF01:'Application Date',
    _6578FA0F46601CB1:'Through deep cooperation with numbers of  global credit institutions,  and supplement with our own strong global enterprises and contacts database, our reports are richer in dimensions and more authoritative in sources',
    _CC460B86EEF36CF8:'Our reports are more timely and reliable in information sources',
    _1371C77138ED9AAF:'Endorsement by the Ministry of Commerce and deep cooperation with Sinosure',
    _5B1236067DD84713:'Click to learn more',
    _26C744CF786A25FC:'View Orders',
    _22747DA2A2747895:'No credit report order',
    _A612B96531F231D1:'Current status',
    _7E80D8F7ADA852BD:'Authorized by numbers of third party professional institutions',
    _95C0C7F12341FFA2:'Apply for Reports',
    _80C62F890C02F431:'Authoritative Reports',
    _6DE542B953C37BC1:'Sources',
    _6E69DDCDF84B67A8:'Image',
    _F84707B16E88FF4F:'Please enter company profile',
    _55AF2BB7CFA6BECB:'Please enter company address',
    _CCA8492573EEDEE4:'Please enter your company name',
    _E5045AC26D916EC8:'Please enter company website',
    _8FCF84D29F9440B4:'Please enter phone number',
    _A041312AD39734AC:'Please enter position',
    _24766E81F40FB409:'Please enter product name',
    _6E81ACABF997F07C:'Please enter product link',
    _BBA525751F12547C:'Scan QR Code ',
    _F3F10B0F0BBE9018:'Please enter your name',
    _87F56D6DDE8FF2F6:'Please enter video title',
    _D249629C857C5956:'Please enter video link',
    _1FD463EBDD1452CD:'Please enter nickname',
    _E9F8F758E2324B3D:'Cooperation intention',
    _4EA97E5CCC763FB7:'Please enter cooperation intention',
    _145D3B50F1C65623:'Please enter product description',
    _DACD26E1E0197D64:'Renew fee',
    _DD878D978E31EA06:'Are you sure to log out',
    _FF0AF67F625735F0:'Degree of completion',
    _CEA635073460701A:'Welcome!Please login',
    _B75001EE26EA6ADA:'Add ',
    _19E56442F3554017:'High quality customers are more willing to know you through company information',
    _C2A75AF02C38DC7A:'Product information can help your customers to know your business better',
    _3FD16FA1F35EFB40:'Product video can help your customers to know your business better',
    _BFFDA1865D21A913:'Please select payment method',
    _ACAE32A8C1463483:'Please enter the amount',
    _30C93B4C2CE8655A:'Select country (required)',
    _204A8B0DE1C7A516:'Pay by balance?',
    _08A891FA115F2C88:'Please fill in your information',
    _20B8D1FFA26B2F95:'Upgrade basic equity',
    _746A2FEF796B2FD4:'Confirm purchase',
    _5CF0D4FBC45C250D:'The amount of VIP purchase will be deducted from the account balance. Do you comfirm?',
    _438F9E43E1A959C3:'VIP members can enjoy more results and content',
    _8466CFC1BDE2C800:'The amount of VIP purchase will be deducted from the account balance.Your current balance is insufficient, please recharge first',
    _DF3E6ECCA3A60FE9:'Your balance is insufficient, please recharge first',
    _AEAE097E13745073:'Buy VIP member',
    _C6538AFEC03F24C1:'No one  has come to see your business card yet',
    _D79B54A98B79B8C1:'',
    _7D5F4999A5CC827A:'Setup A Model',
    _4E6E7F7BFE8169B8:'New Visitors',
    _31F795B5F41A9FE3:'You haven\'t setup recommendation model yet, no contact recommend for you',
    _32104946EBB960E2:'Switch to multiple languages',
    _A70FD084FAEC443A:'By month',
    _8C96E30C670B5891:'By year',
    _456688C99252FA2E:'Unlock more functions',
    _64D5C8673BB8F01A:'How to Setup?',
    _4730CCE1B79DE2A5:'Save and Recommend Now',
    _7DC9B5653A2BD35E:'1. Select  country/region of your target company',
    _746FDCB27867BB15:'2. Select  industry of your target company',
    _8BDB857A37668BD2:'3. Select  product keywords of your target company',
    _1E215EEF39167C20:'Swipe left to learn how to select country/region',
    _5362CF90FF87E4F9:'Reset/Finish',
    _2B68D86CBA3FB874:'Select country/region',
    _256DA7250214A80E:'You can click to select country/region of your target company',
    _3B188C8DF30F1D2F:'Or you can search directly',
    _17C24C6A224F3C4D:'The same operation as 「select industry」',
    _AB0335EA03C29B9C:'Return/Add product keywords',
    _F1C35B3B683375F7:'Enter the relevant product English keywords in the input box below, save to add',
    _5413A3E4E1642701:'Companies/Contacts',
    _50BD2620868A8B1C:'Home/Contacts/Messages/Me',
    _B9B2253A4EBA87BC:'After finishing the first three steps',
    _3B3986650C937A95:'Please wait patiently for one minute',
    _1DD1D5C11026B486:'We can recommend companies related to your keywords for you',
    _106DB61026A0791B:'Setup recommendation model now',
    _1ABDD4D64F5C0C42:'Fill in information',
    _4166A621A795BC84:'Yesterday',
    _3595C580A9AB0285:'a.m.',
    _CA09B3665287F4AA:'p.m.',
    _AFADF43F52FB6905:'Please enter the correct website',
    _E68B2261EE8E6899:'The company product certification you submitted has not been approved.',
    _A7CB86092D86DFB1:'Company product certification',
    _98208C886D54F363:'Company video certification',
    _AE5564A6CA1DB1E2:'The company video certification you submitted has not been approved.',
    _47212B2A31F7346E:'Deliver a business card.',
    _C1E0E527F26F1D2A:'Explore Global B2B Businesses',
    _B17BE4E8AD3C9E02:'Recommendation',
    _7CCED0C7AD9BF19F:'Three dimensions to get recommendation',
    _2459C97CE64348EE:'TIP: You can search by either contact name or company name',
    _3DD7B3335FE19E1F:'Your visitor quota is insufficient. Please log in to get more quota.',
    _3C5EDF0F9B015F4C:'Your free membership benefit is insufficient. Please log in to get more quota.',
    _DB3D9F850AADE4C3:'10M & Under',
    _735F419348184BE2:'500M & Above',
    _2D87D57A021E8E69:'The company product certification you submitted has been approved.',
    _58168CD3BA104F43:'The company video certification you submitted has been approved.',
    _F833A80FD32FEEC3:'The company you submitted has been reviewed and approved.',
    _925FDE7C6A030B21:'The company you submitted has not passed the review. Please modify it.',
    _BC5AF4CFD36D9016:'Your feedback has been reviewed and approved',
    _A82AA0B54FFBE49B:'The company certification you submitted has been approved',
    _9EDEE033649A56DD:'Your feedback has not been reviewed. Please edit it.',
    _53FFBC95D195CF41:'Cancel Successfully',
    _2CA848FCBD770722:'For a required item',
    _312ACAD1FF0A39A4:'Incorrect format',
    _7169151B41C5BFF3:'The longest can not exceed 200 characters.',
    _EAC4C57052393977:'The longest can not exceed 3000 characters.',
    _EBAAE2755D3574F5:'The message cannot be sent without a contact email',
    _E426FF53CFFAF916:'Please enter the correct email address',
    _27DBF999E04B540D:'Please enter the correct phone number',
    _2503845CE8F283C4:'Sorry, no recommendation results, please replace or add product keywords to get more recommendations.',
    _923244C0417432E4:'Company,product name,website',
    _C2C5D7C90EA01220:'Enter company Chinese name',
    _37D5D1B1DB2F8FC8:'Sharing from Xieco - Global Corporate Due Diligence',
    _6C604C8A149EA289:'I am {0}, this is my business card on Xieco',
    _E967F89720749A17:'Avatar uploading...',
    _1395F408DC9CCE9D:'Enter company name',
    _9047BDF14CD8BF48:'Business card recogniting...',
    _CE91A176EC28536D:'Business card information is incorrect, please re-upload.',
    _EE333F1C4AECF8CF:'Account binding success.',
    _E9FEC2CAD1376BD7:'1. Complete business card',
    _A5868E08463269CD:'2.Search contacts',
    _71373C2177B34D12:'3.Send business card',
    _FA55F7DA5BF4852E:'Target company address',
    _3B7AEC1AD6F14885:'Target company contact number',
    _6072A3E91A3740F9:'Your company name (required)',
    _1DB9ADC2536CC2F8:'Change to English',
    _B526CC68B431E731:'Please add industry keywords in English',
    _1457C9D1A51E05DD:'Company name in English',
    _7AD0DF1E3558BB99:'Sign In',
    _33DD0B9E0A03119F:'Join Free',
    _DE45166EE6F9CE16:'Forgot Password?',
    _006A08FB0A747BFD:'Conversation Details',
    _6D3438C37E417B7C:'Search-filter',
    _96D58E47CB7EEDA1:'Company Details',
    _93BBD91700D155AB:'Chinese Company Details',
    _0CDF68EF62DF195C:'Chinese Report Comfirm',
    _F248A7347208F73D:'Recommed Model- Guide',
    _D7A6B05D1BBE59B6:'More',
    _228B992F75D4FF9D:'Search Contact- Filter',
    _2EC0179AA78987A4:'Search Contact- Details',
    _7A370DAF7979B9E2:'Product Details',
    _9C4A6D7B55EC4D38:'Settings',
    _542854D02CE4D2BD:'Upgrade to Vip',
    _0F1CDB7EAD42C0C1:'My Business Card-Share',
    _3D458DCC79E1D49E:'Profile Views',
    _D2C9E019EFCCF118:'Favorite Contacts',
    _CA544D73C2BEE0C3:'About Us',
    _8E4C5C76E365466D:'Edit Basic Informations',
    _D6629A08950AF142:'Product Keywords',
    _2E92CCA6F13BD294:'Add Industry Keywords',
    _DDDE8D06F0BAD418:'Add Sample Company',
    _CCC241E1DB1A9CFE:'Non-Chinese Report Comfirm',
    _1F05AB5B4617520D:'20 companies/month',
    _1D91425FA83D8B22:'5 contacts/month',
    _58CBB215C0205A86:'200 companies/month',
    _BAF67580FA843F02:'2400 contacts/year',
    _D6EE4F85B5B243F7:'20 contacts/month',
    _FB325EB1EAE575BE:'240 contacts/year',
    _CFE0B4E045DE68E8:'$696/year',
    _D2C82D8E772C3110:'$58/month',
    _7B1F66AD23E5BBB3:'Contact without email does not count',
    _F2715239824AC9A8:'The VIP quota for this month has been used up, you can recharge your account balance ',
    _C162E28BF9E5D023:'Compliance with Laws and Other Regulations',
    _B0ED9BEF1EF26A92:'Activate Code',
    _5775636DD32E6736:'Activated',
    _4257BAF75814866B:'Unactivated',
    _4ED72DE9E7BA3BE5:'Single-line Input',
    _D73DF50151F45ADD:'Your Account',
    _A1B697CE43E52034:'Channel Verification',
    _BC236D2941487EED:'Verified',
    _0CBC920BD1D92A9D:'Your Invitation Code',
    _728EB0049CE09AF7:'Invite',
    _9CE4635E4A8FDE2B:'Your Invitation',
    _F053A00F03AAE978:'Registered Users',
    _F79C14A1E14CB74D:'Paid Users',
    _7C2DF48B87951558:'Commission Record',
    _E02079F5DE6C8A0D:'Commission Note',
    _85334F574AEE7D72:'Commission Amount by Month',
    _5B32BC308E8A36EA:'Total Commission Amount',
    _34DDDFCE59B16591:'Commission History',
    _1B43DD105E94DC0B:'Verification',
    _335DFEAC048E42E6:'Channel Home',
    _6BD18044F5CDB307:'Paid User List',
    _62BE7862DC05E477:'Registered User List',
    _23C18B187F28FDE3:'Channel Login',
    _B35AF34E026EE73A:'Channel  Sign In',
    _6026301229759FD0:'Channel Forget Password',
    _CD055FA2BBA89255:'Invite you to join Xieco',
    _8F4983ECD8641126:'Sign in by invitation code',
    _1BD1BC6BB5D9D792:'Login by invitation code',
    _4BDD9A2BA697DB90:'You haven\'t used invitation code to activate, are you sure to give up?',
    _47C461DE810A8E28:'The invitation code has been verified,  cannot be used again!',
    _C81768AB3CE0FE5D:'Your VIP trial membership benefit is insufficient. Please upgrade to get more quota.',
    _907DFF9D49C512B6:'Verified successfully',
    _2A6602F7ADE96B65:'VIP trial member',
    _4999DD23C9B4969C:'Verification failed. Please check your verification code',
    _C946C49D58E4948E:'Wrong invitation code!',
    _98F69A268185AFBC:'You have already been a channel user',
    _0AF9F342E850E45B:'Activation failed. Please check your verification code',
    _426732F635E5C92B:'Commission Amount',
    _C8CDD849E20AD8F1:'Your amount is available for withdrawal,please',
    _1E68E1F546349DC5:'Contact Us',
    _D5EB594926AB3E7C:'You have no commission record',
    _F5060CDAD153F42B:'Dial',
    _A3BA3419078A6C22:'Your account has already been activated',
    _CA12E8C438AD2B68:'Not withdrawn',
    _FFC52BC27D3B66D5:'Withdrawn',
    _0A3BC336CBD8ED20:'Verification failed.  Please check verification code',
    _105B1A402251877B:'Channel Commission Notes',
    _142A42E47A6A15C0:'No Users',
    _6559215FDB326398:'Commission Proportion',
    _FD04666F6CE71785:'1.Xieco account and credit report commissions are based on the sales amount.',
    _1276F955F5E503F2:'2.The commission proportion of recommendation account is calculated according to the actual amount received.',
    _8BA372923BBE5542:'For example, if the user uses invitation code to buy account by year, he/she will get total 200 yuan discount, and his/her channel sales will get 1200 yuan commission.',
    _396B1676E6054F05:'If the user uses invitation code to buy account by month, he/she will get total 15 yuan discount, and his/her channel sales will get 80 yuan commission.',
    _C0201275B4F60B07:'3. Users who buy overseas enterprise reports ( including standard and professional reports) through channel will also get 50 yuan discount. The same goes for Chinese standard enterprise reports (excluding Chinese non-standard reports). The channel sales will also get 100 yuan commission for the purchase. For example: if the user uses invitation code to buy an overseas enterprise report, he/she will get total 50 yuan discount, and his/her channel sales will get 100 yuan commission in total(excluding Chinese non-standard reports).',
    _BC9F61F237C14488:'Commission Settlement',
    _6BBA574C6677084A:'1.Settlement Period: By month( We will provide additional channel statistics page to calculate commission)',
    _DFD40F8952ABA1F2:'2.Commission Payment: The proportion of commission is only calculated according to the actual amount received, the amount not received is excluded. The commission is settled by month according to the amount received as recorded, and the commission will be paid on the settlement date.',
    _B75024CC56B14692:'Remark',
    _FBA15BC2DEA7A3DA:'If the channel sales have any behavior that harms the interests of Xieco, cheats Xieco or its customers, Xieco has the right not to pay the commission',
    _6482D8FAB21B320C:'Obtain accurate enterprise data in multi-dimensions',
    _3A85B6B0FA45F1EE:'系统语言切换成中文',
    _3C398E83EE740BFB:'Email  or Phone Number',
    _97E4540DDFAD303A:'BACK',
    _008DC10B30A15469:'More',
    _1F0A183A6F70F528:'Products',
    _64C64F83252BA697:'Videos',
    _3792D195E0C700C1:'Please select country/region',
    _B544528A0A0E4713:'Complete it',
    _8B1F09E0F1E87CDD:'Get this contact\'s email',
    _3346E48D36F8380D:'Other Amount',
    _EC32642CD78B5A82:'Recharge',
    _B3C7F51625BB72DF:'Sign In by Other Account',
    _D8B6AC08C2CD0674:'Apply For Channel',
    _A6C4DF4674B975D0:'We will contact you within 1-3 working days',
    _3EE1246CAF9656BC:'Channel Policy',
    _364CB3CE0194210F:'Apply Now',
    _2B0A1353976366BF:'Please enter a valid email address',
    _6E92C1509D8C851B:'Your application has been submitted successfully, we will handle it as soon as possible!',
    _56DC7C19341797D9:'',
    _870E0F560ADB9AA1:'By Contact Name',
    _E0E830573707B40A:'Company Name',
    _85B3B1240C062DB7:'Connect for Sales',
    _85D4FC75449B174A:'Improve Marketing ROI',
    _916C2C486DE99AC8:'Recruit faster, better',
    _C7D90ECD6D254CC1:'Before you open the door, meet who’s on the other side. Make the most of every minute with complete, accurate and always up-to-date business contact Xieco. ',
    _0779D3CB7FF6C398:'Improve your marketing ROI with complete contact lists that let you zero in on the exact audience you’re after so your message always hits the mark.',
    _5BF50D7DC6CADD5C:'Stop wasting time with bad candidates. Xieco.com Connect lets you identify candidates with criteria that matter like geography, title level and industry.',
    _344FD45EA2EE5E03:'Find Customers Faster',
    _5CE0A4B3BC8107A7:'Data of 140 million B2B enterprises in the world',
    _C7C9B431C00826A2:'Enterprises',
    _66D1246A0FF85CF1:'Sub-industry',
    _E013FC93453F0442:'Get Report Now',
    _0A8C7B53565DE4F4:'',
    _1AAF2B8BC38FD923:'hundred+',
    _AB08C4D999BBC98F:'second',
    _39DA9AF2424004D3:'Credit report discount',
    _23D438DAD266872D:'Are you sure to quit？',
    _68A74FF668CE7E34:'Please enter email or phone number',
    _5A2E90BA67ECCC51:'Policy Statement',
    _571EE0F5A5CDE070:'1.Once you have become our channel member, you have to complete 5 VIP invitation orders or 20 registered users mission within a month, or you will be disqualified',
    _990EC6181F88582C:'Reply',
    _A0C9E3866113F49A:'Read',
    _E8875FC27ECE4137:'delivered',
    _BA41D31BCBE087C8:'failure',
    _0F5EB8EB13231C8B:'Complete your social information and phone number to view 5 more contacts and 10 company details',
    _19244C36B08E82F7:'Complete Now',
    _B13168073E9CA5E8:'You have already registered, please login',
    _38762453AF5C0B8E:'Only the following 11 countries provide real-time reports: UK, France, Germany, USA, Italy, Ireland,  Netherlands, Belgium, Luxembourg, Norway, Sweden;Others are required to submit applications online.',
    _DC6B0ED504FAA4E2:'Note: ',
    _D5B32478DB2D6591:'Facebook Messenger',
    _51B30CD35F8DC015:'Please use VPN to access internet',
    _CD6469AB08E74D3C:'Hi,please check my business card, I\'m looking forward to chatting with you.',
    _602052E989EC072C:'Your account has been linked',
    _B00512B810F41BD2:'Order paid',
    _24DEB4D85383A60A:'Recruitment recommend',
    _EB6F0CAEC548EA0E:'Opportunities recommend',
    _B6B0759CDA8CA898:'You can only add 10 keywords',
    _3001F626F2E1CF62:'Are you sure to clear history?',
    _A7B26DFEE1F3446A:'You can change your recommendation model type in setting- model select',
    _FBE1BA6C807D22CA:'To get more accurate recommendation, please fill in the following model information as specific as possible.',
    _8E930E0F8DB22FCD:'To get more accurate recommendation, please fill in the following model information as specific as possible.',
    _07B69FC78B63B242:'No keyword',
    _9B70996C4B1B3131:'Search companies and contacts.',
    _5271CA1D819B0F25:'B2B sales leads Recommend&Predict.',
    _E590E3630FC9EBE8:'Home visitor real-time tracking Communicate instantly with potential customers.',
    _A50EB7F005B5762B:'Global credit report help you avoid credit risks',
    _C4BF7A8EE279F260:'Select a recommend model to start',
    _D2B8D4A2C1234C1D:'Find Business Optunities,Patners',
    _6E228FBD5934C8A0:'I Want Recruit Applicants',
    _E68B097F9DC1C108:'start',
    _23C34579B6A6FCEF:'History',
    _B8C231B0DCD9E1B8:'Advanced',
    _60DF9C64E3FE3A60:'Advanced Search',
    _EC733607091B1EFD:'Normal',
    _1A594C595C4CBAB9:'Related Recommed words',
    _037055B2B47563D8:'Display on the homepage,10 keywords limited',
    _43AFE88DE60C66AB:'Prepare Recommed data for you,just wait a minite.',
    _3D6E79FB296D1D0B:'Hot Contacts',
    _0BC89403D10CACE7:'Complete your social information and phone number to view 5 more contacts and 10 company details',
    _49812C7632A5EEE9:'Retrieve password by phone number',
    _F37CF06F2CE9B91C:'Please enter new password again',
    _173F2CA1EE16789B:'Please enter new password ',
    _2B834EBD7B7C6276:'Next',
    _3F2C632FFA3E59E1:'Your passwords do not match,please enter again!',
    _D11A567143E9A9AC:'Password modified successfully',
    _DAA57F5B1AF692A9:'Failure',
    _BDE330FB38F28429:'Chat',
    _24FBFBCFEE41BD22:'Visitor',
    _B6A12CBF4387FF90:'Your Business card will be display in chat.',
    _B473B58DE25D5056:'Change Company',
    _C5594F009A1C7922:'Create Enterprise Homepage ',
    _85B4D0A928ED1C07:'Fill in real business information Create a safe and trustworthy business environment together.',
    _883CC3AB1876E58B:'Please fill in basic company imfomation',
    _1143FE11B3874EAD:'Business license + business card certification',
    _3506DEE0113100F2:'Business license + badge certification',
    _FE2F68D0FA8FD635:'No message',
    _46D8C487AD18F3C3:'Vistors',
    _989FAEC49947CEB1:'Acquire card information successfully',
    _3125ADF7FCF2867D:'',
    _FD51235D88CD881B:'Your message has been read,please complete your information to get connected',
    _D617EBCB61969AB1:'Your message are delivered but not viewed yet, you can use other social media to communicate',
    _9FD8C5F13D6E6BC1:'Your message failed to send, it does not cost your message quota. You can use other social media to communicate',
    _04183984276984D4:'Renew VIP membership',
    _02DAAB5934951409:'Leads model',
    _2A873EC2F3295FDF:'Recruit model',
    _5E384C4CAA6AF200:'Your company need to be certified again if you change it',
    _2EB147ABD2391214:'Pending',
    _69DAF4311E328D8A:'Advanced certification',
    _99A0F50EDF22548B:'Suspend',
    _F7FD28AD0F1608FA:'Your materials are kept confidential and only used for certification',
    _6EE80D4996DA7078:'Details',
    _2980CE3BCC0AC070:'Amount',
    _E7BA9E7EA2658238:'Unsubscribe failed',
    _DE707CD54B99CBD7:'Unsubscribe successfully',
    _7A435CE271D63983:'Join our membership',
    _AB23295581549C92:'Please upload your business license',
    _B58A5B6D0E75A74A:'Login with phone number to find customers quickly',
    _557F966963A16453:'Create a new acccout',
    _A4F94C004E367D0B:'Don\'t have an account? ',
    _B8B47AE5C4400C78:'Join us now',
    _449832D39D28AA3A:'Login with password ',
    _873A6BA26DF61FC6:'Sorry,we couldn\'t find your account with that email. ',
    _A4F5EC59ED740333:'We\'ve sent an email to chen@socialbird.cn',
    _DCD1721D31CB694F:'Click the link in the email to reset your password',
    _6256654FB5E8D544:'Or login with',
    _1A773E94D8F3CAAC:'My Company',
    _6A830108A01B2D97:'My Job Title',
    _1353CD0B48B0F4DD:'Your Wechat  ID is already tied to other account',
    _44817BF07F086A37:'Your company is ',
    _CEC257C6291C92B6:'My Points',
    _1F1D8ABD4002687D:'<span>{count}</span> points will expire on <span>{date}</span>',
    _4E32676F63C9E983:'Instructions',
    _EE962E7A6A575C03:'Total',
    _CFB36049B6C0AFF2:'Income',
    _8434ABDE22B5CDFA:'Spending',
    _18BBF1BA230531D3:'Details',
    _3753645B7E1421F0:'Date',
    _AB57A2867860BDA7:'Use my points',
    _F8EAB2F697012CC3:'Points',
    _03CB969AC82E256D:'All',
    _2F7EA45FFFE3181C:'Within <span>{count}</span> days',
    _9D1E460B92E22023:'No Data',
    _AEDAE9AA4984C8B8:'You have <span>{count}</span> points, please select a product type you want to redeem',
    _AE49597094535F9F:'View contact email',
    _51FBAD1C42AFD5EB:'View company details',
    _BECD660987574F5B:'View  personal social account',
    _6DF63609E350EC0C:'Send Message',
    _6111BA178DA62D1C:'Points',
    _052A0572AD3F7107:'Type',
    _95EE555BF0D4A5C2:'Number',
    _229340AC51ED1E20:'Total',
    _2893BF26F891AF67:'Upgrade',
    _B376BF217A597938:'Back',
    _588ABF7E3B9A28F1:'Confirm',
    _2DC2F8692A286619:'Within 30 days',
    _55016D5872745BF5:'Within 180 days',
    _10167B6FCDFB782E:'Within 365 days',
    _68A3995934AA02F8:'Xieco VIP Service Upgrade',
    _3BEB5EC9C32B7A65:'Customized for business people，find your target contacts quickly',
    _D9BB9ED51C92E839:'Learn More',
    _31B0C07D0ABB4E8F:'Xieco Data',
    _B31F27737A686C25:'By Product Keywords or Company Name',
    _B749DD2A72BF6407:'140 Million',
    _F0D11BA2F72BB2CA:'Industries',
    _BC4272E4C431DE9F:'Contacts',
    _4EA87CA412FA79DF:'Facebook',
    _7CB2DDE1CD40D2E0:'30s get report',
    _B8B856AC398A7A72:'Credit certification/collection/factoring',
    _8B2AD073CEEAD54B:'Enterprises and Contacts of 216 countries',
    _D8F70929024671D0:'Company Directory',
    _70733CDD441F8C4C:'Browse by company name',
    _43FAE2C94CB9821E:'A social tool for global trading companies and contacts',
    _77AB7CF8BD0F86F4:'Get 10,000 company information for just $2 per day, click to buy now',
    _65264915D1AA9096:'Xieco VIP Data Package Price and Benefits',
    _96EB1A2D0D319711:'Package Type',
    _FA772CEA3872929C:'Package Price',
    _7FA9A44BCC6E780F:'Period of Validity',
    _23E21AAFCB529692:'Simultaneous Users Online',
    _590F8043B545E3BF:'VIP Benefits',
    _F29C5F7F4BD6E42D:'Monthly Package',
    _4D1922E6E1A62DE3:'Quarterly package',
    _B8D34DAC4DE3D1B9:'Semi-annual Package',
    _647D1BC9E5D4E37E:'Annual Package',
    _F68731BF30C6D6FF:'Buy Now',
    _C6B1159F04279B97:'1 Month',
    _8EAC5F3B1C8DDDE3:'3 Months',
    _8DCB106118246E1B:'6 Months',
    _E2421060E4B97E01:'12 Months',
    _2023CF429CD0DE66:'Simultaneous Users Online',
    _C4F865E57E7C90B7:'Benefits+20%',
    _0DEB9CECF09C0749:'Export Data',
    _A72A7E36CEFC8141:'Export company data',
    _1354FFCD976768E2:'Lock Target Customers',
    _B5A4381117F508EB:'View company list (1000 pages)',
    _677CFC6879FDD3AB:'View facebook（1000 pages）',
    _A9234E81A0A830B7:'View facebook details',
    _B7961A6865C64D35:'Contact Efficiently',
    _841B0B18D21CBE86:'Send email to target customer',
    _CAC9870C876EB137:'Send facebook messenger',
    _DA1496E51CA18063:'Single Pack-Buy Single Service',
    _5EF37453FABC3894:'Type',
    _2E469ACDFB291633:'Content',
    _8B4A25C684B6E0AD:'Single Pack-View Contact Email',
    _676616EDE85D3013:'Single Pack-View Company Details',
    _3128E373BA3F2E81:'Single Pack-View Social Account',
    _120BEAFFBA5A67A1:'Single Pack-Send Message',
    _BEB79A09ED580B53:'View target customer\'s contact email*1',
    _D3DC67549ED07FF0:'View company details*1',
    _24589C4F33C1A5B1:'View personal social account*1',
    _6C53860262CEB10C:'Send message to target customer*1',
    _15B57482F2F0E565:'Multiple Choices, Applicable to Various Scenarios',
    _AA44493F4B0D33FC:'140 million B2B enterprise data, over 400 million enterprise key contact information',
    _F05469193B97F3FE:'Build customer list for sales group',
    _6DDF8CA9F3BC9DD9:'Find suitable candidates efficiently',
    _B3338999BE1CB4CE:'Explore global customers quickly',
    _43D1C28F63F75827:'Know the overseas market prospect better',
    _844C9D7476024708:'Track business data of competitors and partners',
    _3882130FD053559A:'Avoid risks and ensure transaction safety',
    _4154A3DB616B7A96:'Confirm Payment',
    _D1226BA6735A6C8D:'You have selected',
    _C7AAD1CD5D9FCD04:'Paid Amount',
    _783C0154A9B122A5:'channel discount',
    _2E301881AEDFD0AE:'Please select number',
    _4F5BB4FF8B3D804B:'Confirm',
    _2E511950B65244C7:'Contact',
    _7657672C881EBD51:'Before you open the door, meet who’s on the other side. Make the most of every minute with complete, accurate and always up-to-date business contact data',
    _77B64F300B35CF3B:'Improve your marketing ROI with complete contact lists that let you zero in on the exact audience you’re after so your message always hits the mark',
    _F32850B8A9E82DD5:'Stop wasting time with bad candidates. Xieco lets you identify candidates with criteria that matter like geography, title level and industry',
    _3858AA3A43F459A2:'Package Order',
    _686E3EA3EFAD37C3:'Report Order',
    _69EEEF5748E852C1:'Operation',
    _8F13FA997BAEDAAD:'Unpaid',
    _E292B9EF3A399EE4:'Completed',
    _84EAE80A1D012926:'Invalid',
    _05D6125395E3C7E7:'View Details',
    _25AF4E2F8690AE07:'Delete',
    _82C50AC706BB4533:'View company list',
    _60BF6B11512CBEB4:'Send message',
    _5870C192FAC1EEA9:'Remaining pages',
    _10DF03B39223BB12:'Remaining',
    _B0E4375E1B031799:'Used',
    _2C3A5F985737A8A9:'Expired',
    _D32D883DAE20353D:'Expense Details',
    _F1B99979E1B7D5B4:'Details',
    _0C9B77AC17EBAD7F:'Date',
    _D93621A8D2D68018:'Upgrade VIP',
    _7F28764B786320F9:'Company Certification',
    _D6D6566556C3D365:'VIP Package',
    _7F308959CD74F262:'Benefits for certification',
    _758296A5045A5A59:'More Exposure',
    _F9FD779FAD0D3F43:'Global B2B buyers can find your company in the company library',
    _99BA2EA6CF829212:'Earn Points',
    _8BCB871BC3E7CAC7:'You can get 100 points for company certification. Points can be used for viewing contact email,etc.',
    _76CBEAB49C1CC678:'Advanced recommendations',
    _73759755906D8208:'We will recommend more targeted companies for you according to your preference',
    _B166E4E8FE9513FA:'Country/Region',
    _6946655DE7F72092:'Please select country/region',
    _0F99D46E818819F8:'Please select number of employees',
    _8758FD50C87D6C9C:'Address',
    _FD8587589210CB9F:'Please enter your company address',
    _3D5CE01C5F6E820A:'Business License',
    _B022BD8F08A02EB3:'Working Badge',
    _3BA773287B7DEF95:'Please upload picture',
    _5AEC26A6B7BB80E8:'Note: You need to upload either business card or working badge',
    _17F2456ABA6229BA:'Submit',
    _F15FCB490CFA7DF2:'You have submitted company certification successfully. We will review your materials within 3-5 working days, please wait patiently',
    _18A470EEFF7A2BED:'Status',
    _FC3D3C119118CFFC:'Modify Information',
    _99974E94A167C813:'You company will be reviewed again if you modify company information',
    _1B8E1319E4881C25:'Congratulations,your company has been approved! You have earned 100 points reward,  you can check and use your points in "My Points" page',
    _993C4E2A71557FE7:'Approved',
    _C9815C7193A12837:'Change Company',
    _1294A3AED15D022E:'Price and Benefits',
    _E55D90826AD83005:'Benefits',
    _CD4657BF621206D1:'Xieco VIP Data Package',
    _CF658B12CFCACE9A:'View company list',
    _C9B453CE1F6E81A0:'View facebook',
    _62EDE6F38D74952C:'View target customer\'s contact email*',
    _DF78000CFB3A3DAF:'View company details*',
    _93B1BADF4D561AEA:'View personal social account*',
    _D9A3A5133BD74670:'Send message to target customer*',
    _D5409BECB32337C4:'Build customer list for sales group',
    _8A68FC40A519E93D:'',
    _628916824D3611C6:'Find suitable candidates efficiently',
    _E1678256F89F2F07:'',
    _6A246988E6574D4C:'Explore global customers quickly',
    _76502B4C0B2CC606:'',
    _90700C0A59C88173:'Know the overseas market prospect better',
    _5560BA1B53C02E4B:'',
    _512DAB7B61817835:'Track business data of competitors and partners',
    _D61A8BFACAD470FA:'',
    _4976DD8DEFF79A51:'Avoid risks and ensure transaction safety',
    _6C521DB90B48332E:'',
    _C10448D12335D659:'Your company will be reviewed again if you change it',
    _7B5766A1C5EF255D:'Sorry, your company certification didn\'t passed, please revise your company information and submit again',
    _735DF2DCA58C4F9B:'Submit',
    _7FE92F41627D9A70:'Suspend',
    _EDC06299F5ACEA79:'Basic Benefits',
    _54D0E13A0A2F880B:'Certify Company',
    _58E3259AA361FB13:'Paid Amount',
    _C6C48A3A73691AAA:'Package Price',
    _087FA94C1AFFC0E0:'My Quota',
    _515CC1FF24493A7B:'View company list',
    _A01B988E7E9A6DC2:'View company social media',
    _B2E08912B2D8BDA7:'View company social details',
    _85269AFA54303AAE:'View social account',
    _C5DC9F9EC32360D8:'Send  FB Messenger',
    _3B80861F5CC1D41F:'Order Details',
    _EED7E53868D52E10:'Your order has been submitted, please pay before',
    _DFAE9AA678140754:',or the order will be cancelled automatically',
    _BBD0E1F1214BCA9D:'Become VIP member to enjoy more benefits. If you have any problem during payment, please feel free to contact us',
    _DDB77881EE372EBA:'Pay Now',
    _AA37B3A822347601:'Your order has expired, please try your purchase again',
    _43B4D384BC9DAB4F:'Learn VIP Benefits',
    _161AA79CAB995327:'Number',
    _CD390002E8406C5B:'balance deduction',
    _8FD6CE9C58001E36:'Payment Date',
    _5FF8D4C1679F272E:'Minimum of 5 characters',
    _7E461A1085F629F3:'Follow us',
    _1D6BC498A0AD979C:'Find customers quickly',
    _7005434934422454:'Wechat',
    _82725C780D821B2D:'Please enter at least 5 characters',
    _795E7E3ECBD225AB:'s get report',
    _93B20BBDF1ADBE0A:'Directory',
    _88233F21F5A4D78F:'Browse by company name',
    _8A182451A9CE6F93:'My Xieco',
    _BF665AB539D16DC8:'Maximum',
    _412F91CC17DC0AC9:'We comply with all national laws and policies and other regulations relating to the protection of personal information.',
    _DEC5D681B64A5632:'Establishment and Continuous Enhancement of Personal Information Handling Guidelines',
    _A4A36D4856D34219:'The need to protect personal information is thoroughly promulgated throughout the company, from directors down to the most junior employees. We maintain and follow guidelines for the proper protection and use of personal information. We also strive to improve these guidelines on a continuing basis.',
    _B3757F11D1BCAA7F:'Acquisition, Use and Release of Personal Information',
    _73D2FA4D2C92EE73:'We clearly define the uses to which personal information can be put. Within these constraints, we acquire, use and release personal information only with the consent of the individual concerned.',
    _60C5902D4D65DE2C:'',
    _059BA874B494B559:'',
    _01F52D5C5AD86CA7:'',
    _58365E0B7C28B1E7:'',
    _654DBD543EDC5D26:'Secure Management',
    _609CE37FD7E11B55:'We strive to maintain secure management of personal information, and have established the necessary measures to prevent unauthorized data access, loss, destruction, alteration or leaking.',
    _E98552440A14FC2D:'Today',
    _8F2AC94D299863D2:'<span>{month}</span>-<span>{day}</span>',
    _D90AFC839E21FA5B:'Filter',
    _0F8358C65FE66F79:'Contact',
    _525868CDA60043F2:'Become VIP member,find over120,000 target companies',
    _FB32013333CD2CE7:'Filter History',
    _411D7230C59C0938:'Add to Favorites',
    _678081DF0A506847:'Sort by Best Match',
    _70AEBC7CB2C3BF43:'Sort by Number of Contacts',
    _4B8B490C9ACEF433:'Sort by Number of Employees',
    _8DB2C5A12BA851DF:'Sort by Contact Method',
    _2A3EB2C5085C0F8B:'Sort by Relevance',
    _1D525A47080B3266:'Website',
    _703329EE674D8D5C:'Yes',
    _C792CE60D7B74561:'E-mail',
    _2AF208DE295242D9:'Facebook',
    _2B09804B237266EF:'Twitter',
    _65FFE1FB981C3E69:'Linkedin',
    _0E1AC645D285DEBD:'Contact',
    _F5363AA6057CD9B7:'Facebook Hot Companies',
    _41DDED4E5A874E33:'Likes',
    _7A7BE43D8C529286:'Details',
    _F5B7BDACBDB75254:'Product & Service',
    _F7F35F0718F69267:'Become VIP member, contact your targer customer immediately',
    _D80C976303D9CCB5:'<span>{count}</span> results are found',
    _6BD886529679374E:'Facebook List',
    _A68A744713E0120C:'Social Media',
    _18CED93371CC4D73:'Company Profile',
    _0CEE229E93A8DF5F:'Company Overview',
    _81F1CAB5330BF0DD:'Products',
    _9B5BBEF1BFA55E03:'Mission',
    _FB16C496D4911C61:'About',
    _BD4B710BCC5F4B5B:'Awards',
    _B1A6BA95390AACB7:'Tel',
    _FF67B921FF8F8A58:'I Understand',
    _4186D5B29C4328F5:'Company Information',
    _DBF8358C8B6070A4:'Status',
    _7DC52CA148301B8A:'Company Name:',
    _5D76AA4FE8627E14:'Industry:',
    _6384AE200B496CA4:'Address:',
    _2C2BF85DF52B91B2:'Country/Region:',
    _0286713B19EF5687:'Number of Employees:',
    _DB6870C43D1B8D27:'Approved',
    _0C439D7C35AC71B1:'Edit Business Card',
    _DBF2505F561DE5B7:'Edit Business License',
    _E2FBB28A37D3BBCF:'Edit Working Badge',
    _3B4093E80AA8F2E3:'Please upload picture',
    _BD7218F3625BAF11:'Note: 1.Business license is required.2. Business card and working badge is alternative',
    _5CDEE8373ADDFBA2:'File Format',
    _44EAC0552CD27AF0:'Number of Records to Download',
    _A21303236771D4F2:'Current Quota Available: <span>{count}</span> Records',
    _8DBC350DEE25378F:'Congratulations,your company has been approved! You have earned <span>100 points</span>  reward,  you can check and use your points in <span>"My Points"</span> page',
    _70C234DE98CF9247:'1.Use Range',
    _C48E2D74C079996E:'DD points can only be used in Xieco.  They can not be cashed or transferred',
    _2FD44CB8FEC4A13A:'2.How to earn DD points?',
    _A9F248324C0C18C0:'2.1 Share: You can earn points by sharing company, contact or business card details to your friends. Each sharing can earn 10 points. The maximum amount of DD points you can earn by sharing per day is 30 points',
    _D129F1C573975E27:'2.2 Company Certification: You can submit company certification and earn 100 DD points reward after your certification get approved.( You can only earn this reward once no matter how many times you submit the company certification)',
    _CD27A450824D3F68:'2.3 Buy Data Package: You can earn 100 DD points by purchasing monthly package, 300 DD points by  purchasing quarterly package, 600 DD points by purchasing semi-annual package, 1200 DD points by purchasing annual package.(If there is a refund, the relevant points will be deducted)',
    _2157E8D5E75606EE:'3. How to use DD points?',
    _36E456C79F7D5873:'DD points can be used to exchange benefits.  You can click“ Use my points” button in "My Points” page, and use points to exchange relevant VIP benefits.',
    _7DFAAFBC3A676A4B:'4. Expired date',
    _1FA56E2954C5756B:'DD points are valid for at least 1 year, that means the points you earn now will be expired at the end of the following year. For example, you earned 100 points on Nov.1,2018, these points will be expired on Dec.31,2019',
    _E38BAF2CA6F42949:'Please upload picture',
    _A7580E69ACA1BDAB:'See what other people are interested in',
    _DF14BE791D9932C9:'See hot companies in Facebook',
    _56E64691BE015010:'Login',
    _E014896D68F0D78B:'',
    _5CED18A1AC891A5E:'Clear',
    _3FEC82CE8F08AA82:'',
    _8DB71808C4599307:'Please select industry',
    _53C98343C08C2E0B:'Sorry, your quota for checking email is insufficient',
    _BAE973FB30CFECC0:'Join our VIP plan,',
    _B347062306761250:'build relationship with your target customer for only $3',
    _1F572A3F8A54EB9B:'Sorry, your quota is insufficient.',
    _6E62945C1A3FCDD0:'cost only $0.15 to find your target customers',
    _1C013486334DBBC1:'Recommendations',
    _1B52E217C72A9BE8:'Social Details',
    _833BA210DA47F161:'You have submitted company certification successfully. We will review your materials within <span>3-5 working days</span>, please wait patiently',
    _31118F6057E40723:'Hot',
    _8774F498D56F0267:'Sorry you haven\'t joined VIP plan yet',
    _9E962915E74776D0:'This function is only for VIP members',
    _6B7A506DF07E24EB:'This function is only for VIP members',
    _8516A25B9937E253:'View benefits',
    _0A9E19A467545466:'<span>{count}</span> countries/regions have been selected',
    _03B942E0C95F5280:'<span>{count}</span> industries have been selected',
    _595330AEE6DFB56A:'View social details',
    _3F77F29B048D0423:'build relationship with your target customer for only <span>$3</span>',
    _D19866415C9C2C88:'spend only <span>$0.15</span> to find your target customers',
    _960EAA175D30F453:'Introduction',
    _F06B663440722A0E:'A secure social tool for global trading companies and contacts',
    _ECA5319C024D6D60:'Real-time update',
    _B988E6B78434FD73:'140 million B2B global enterprise data',
    _6D19D21998CDA2B6:'Integrating social data',
    _73A5FA110D45D286:'Over 400 million enterprise key contact information',
    _2F8700942BD73843:'is an intelligent big data platform that facilitates more transactions between global buyers and suppliers by providing sales leads. With world\'s leading AI technology and big data group, we provide our users millions of global enterprise and contact data. Our data grows and updates every day, ensuring our users can find information they need quickly and easily, improve sales efficiency and expand more business.',
    _DDCE6E478C68A5E0:'Until now, we have already helped thousands of global enterprises to find relevant business partners and achieve considerable profit growth. In the future, we will help more global small and medium-size enterprises to find their global partners and explore more business opportunities.',
    _C4DA041BFD213E1D:'What We Can Do',
    _5D62F3D282959661:'Find Your Target Contacts',
    _49154FDEEFE3F71D:'We use the world\'s leading artificial intelligence technology to match the real needs between buyers and sellers and recommend potential customers for you',
    _FF08D7BDA0D3F8B9:'Build Business Relationship',
    _24022185937A834B:'In Xieco, you can communicate effectively with your customers and build reliable relationship with them',
    _8B268CCE0C61A29D:'Make Right Decisions',
    _4F08BC308FA0EF86:'We analyze your target customers in multiple dimensions, offer you efficient decision support and ensure transaction safety',
    _347941C071AE6CCA:'Data Capacity',
    _5592B0E35C55E998:'Data prediction and recommendation/per day',
    _AA3E00B1A9D2605A:'billion',
    _772E3C2A629C768E:'Dynamic behavior and intention signals/per day',
    _8A6D78DEA3A458AB:'Eigenvector',
    _C195EB37AF029F1F:'Global buyers and suppliers',
    _F7A6B6F4A9CF0B12:'Enterprise contacts',
    _9373ABF6DD8E3767:'Why Choose Us?',
    _153177D1FDB74082:'Broad Data Coverage',
    _D7D2F9BC045940D9:'Data covers 168 countries and regions , reaches over 600 industries',
    _C05CA957E3932A7F:'Data Granularity',
    _8E7FE4F59A7F8BAC:'Including enterprise details, contact information and contact social media information, etc.',
    _3911553855F8A514:'Authoritative Data Sources',
    _19884A8F37B741A6:'Reliable data collection channels and professional data analysis to ensure timeliness and accuracy of data',
    _5D4CF1480A06A05F:'Find Target Customers',
    _77FAACDD490B3585:'Various screening conditions and contact methods to help you find target customers easily',
    _89C389FAA18C1F1B:'Fully Understand Buyers',
    _719DCE77B166795F:'Grasp the latest credit trends of global buyers and identify potential business opportunities',
    _F4F5A91B7E986656:'Our Advantages',
    _F9F7BACC44B0A90C:'Distributed',
    _B888517CEC352DD8:'data capture',
    _889B3CA3102BEAC9:'help companies to integrate dynamic and static data',
    _E9DF76CBEA3E8B6A:'Help companies to build customer portrait',
    _226D25B79D019F73:'accurately',
    _DC2F6E3A2C6C3654:'explore high quality customers',
    _C14E1933AAE3EE7E:'Efficient intelligent marketing system',
    _E3C94A87545E3F6C:'high reach',
    _D4A774A5835C000E:'good experience',
    _3EDA8E06EC8D091C:'Low churn rate',
    _FEAD3F6C88F821BF:'Data search engine, public dataset',
    _8082935BAC48B34D:'takes a leading position',
    _818CE541FF39BBD1:'Data recommendation engine, based on customer portrait model',
    _DC9B5221D04F67A9:'precisely matches',
    _98531B67597D79C4:'enterprises, build relationship directly',
    _93330F1C8FEFD289:'Based on natural semantic recognition and recommendation, end-to-end modeling, over',
    _4B0727F8DB77BE1D:'',
    _61C7A729A4CA7963:'2 billion',
    _A42F9ED9DB4DB973:'dynamic',
    _D00DD36669CD0C86:'and',
    _DB550E57457AA660:'intent capture every day',
    _074ABD9CF3AC8535:'Share to Facebook',
    _25A1F35304DA4DBB:'Share to Twitter',
    _B29E6F6C86C23848:'Share to Linkedin',
    _D2CF966D7BBCC322:'Share to Wechat',
    _20A634B518BB8103:'Share to Weibo',
    _ACDFBFD5132FE350:'Register via share links',
    _155042025D07324E:'Buy monthly package',
    _2BBA3753BC01C3F8:'Buy quarterly package',
    _311546848E751761:'Buy semi-annual package',
    _31F4FDD1DDA2CDC9:'Buy annual package',
    _62702A6EDDDA26D9:'View contact email',
    _6A242D1F013C7EB6:'View company details',
    _9E111B4ABDB2A0FC:'Send message',
    _CF0258D0B0AF7F87:'View social detail',
    _75EF6CBEED6A92F6:'View personal  social account',
    _69C3E157024665BD:'Send message',
    _B5898A0C554C586D:'Export List Data',
    _6C683CEC3A7B8B67:'Note: You can export company list data here . If you want to export favorite company data ,please go to "My Favorites" page.',
    _40FB5DC5EF586FCC:'Note: You can export contact list data here . If you want to export favorite contact data ,please go to "My Favorites" page.',
    _345D01829034D9F4:'Export Favorites',
    _807437709BF9753D:'Access to an unlimited growth opportunity',
    _EE3731506832E2D2:'Start From Xieco',
    _FB85E32BE7F6A57F:'Enterprise data, email data, social data',

}
export default gen



// WEBPACK FOOTER //
// ./src/lan/en/en_gen.js